document.addEventListener("DOMContentLoaded", function() {
  setTimeout(function() {
    const targetHeading = document.querySelector('#insta-feed h2');
    const elementToMove = document.querySelector('.instafeed-bottom-link-wrapper');

    if (targetHeading && elementToMove) {
      targetHeading.insertAdjacentElement('afterend', elementToMove);
      console.log('✅ Element moved after h2 (after 1s delay)');
    } else {
      console.warn('⚠️ Required elements not found after timeout');
    }
  }, 1000);
});
